import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Index from './pages/Index'
import NotFound from './pages/NotFound'
import OrderDetails from './pages/OrderDetails'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

export type Environment = 'tst' | 'acc' | 'prd'

export interface AppProps {
  env?: Environment
  accountNumber?: string
  authToken?: string
}

/**
 * Order List Application
 *
 * @example
 * ```tsx
 * import { App } from '@susu/order-list';
 *
 * function MyApp() {
 *   return <App env="prd" accountNumber="12345" />;
 * }
 * ```
 */
export default function App({
  env = 'tst',
  accountNumber,
  authToken,
}: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Index
                env={env}
                accountNumber={accountNumber}
                authToken={authToken}
              />
            }
          />
          <Route
            path="/order-details"
            element={
              <OrderDetails
                env={env}
                accountNumber={accountNumber}
                authToken={authToken}
              />
            }
          />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
